import React from "react"

import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"

import Hero from "../components/Hero"
import Services from "../components/Services"
import Testimonies from "../components/Testimonies"
import CallToAction from "../components/CallToAction"

const IndexPage = () => (
  <Layout>
    <SEO
      title="Home"
      description="Mestre Reiki, taróloga, terapeuta floral e praticante de Barras de Access Consciousness em Porto Alegre. Atendimentos presenciais e online."
      canonicalPath="/"
      jsonLd={buildLocalBusiness()}
    />
    <Hero />
    <Services />
    <Testimonies />
    <CallToAction />
  </Layout>
)

export default IndexPage
